/**
 * Chaves de telefone para mapas do cliente (etiqueta, responsável).
 *
 * A mesma pessoa aparece na base com e sem o nono dígito (553499793777 e
 * 5534999793777). Os mapas do inbox são indexados por telefone, então quem não
 * considerar as duas formas simplesmente NÃO ACHA o valor — e, no chat list,
 * "não achei" é renderizado igual a "não tem responsável", que vira o chip do
 * agente. O mapa de etiquetas já tratava as variantes; o de responsável não,
 * e por isso o chip errado nunca se corrigia (relatado em 28/07/2026).
 */

export const normalizePhone = (phone) => String(phone || '').replace(/\D/g, '');

/**
 * Formas equivalentes de um telefone brasileiro (com e sem o nono dígito).
 *
 * CONSERVADOR de propósito: só gera a variante COM 9 para faixa de CELULAR
 * (primeiro dígito 6-9). Um fixo (55 DD 3xxx-xxxx) receberia um "9" fabricado
 * que pode ser o celular REAL de outra pessoa — e aqui a variante vira CHAVE
 * de mapa (no backend é só candidato de query, inofensivo).
 */
export const brPhoneVariants = (digits) => {
  const out = [digits];
  if (digits && digits.startsWith('55')) {
    const ddd = digits.slice(2, 4);
    const rest = digits.slice(4);
    if (digits.length === 13 && rest.startsWith('9')) out.push(`55${ddd}${rest.slice(1)}`);
    else if (digits.length === 12 && /^[6-9]/.test(rest)) out.push(`55${ddd}9${rest}`);
  }
  return out;
};
